import api from './api';

export const getAllManagers = async () => {
  const response = await api.get('/managers/');
  return response.data;
};

export const getManagerById = async (managerId) => {
  const response = await api.get(`/managers/${managerId}`);
  return response.data;
};

export const getMyManagerProfile = async () => {
  const response = await api.get('/managers/me');
  return response.data;
};

export const createManager = async (managerData) => {
  const response = await api.post('/managers/', managerData);
  return response.data;
};

export const updateManager = async (managerId, managerData) => {
  const response = await api.put(`/managers/${managerId}`, managerData);
  return response.data;
};

export const deleteManager = async (managerId) => {
  const response = await api.delete(`/managers/${managerId}`);
  return response.data;
};

export const suspendManager = async (userId, reason = null) => {
  const response = await api.post(`/auth/suspend-user/${userId}`, null, {
    params: { reason }
  });
  return response.data;
};

export const unsuspendManager = async (userId) => {
  const response = await api.post(`/auth/unsuspend-user/${userId}`);
  return response.data;
};

